/**
 * Created by Abner Sui on 09/26/2019
 * -------------------------------------
 */

import { Component, OnInit, ViewChild, ViewContainerRef, ComponentRef, OnDestroy } from '@angular/core';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { Subscription, fromEvent } from 'rxjs';
import { SlideSheetActionTypes, SlideSheetEventTypes } from './slide-sheet.model';
import { TaskDetailComponent, TASK_DETAIL_DEFAULT_WIDTH } from '../work-flow/task-detail/task-detail.component';
import { MessageService } from '../../services/message.service';
import { QuickTaskComponent } from '../work-flow/quick-task/quick-task/quick-task.component';
import * as lodash from 'lodash';
import { TaskListComponent } from '../work-flow/quick-task/task-list/task-list.component';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { MessageOperateType } from '../../tamalelibs/models/message.model';
import { EntityPanelComponent } from '../entity-panel/entity-panel.component';
import { ContactPanelComponent } from '../contact-panel/contact-panel.component';
import { debounceTime } from 'rxjs/operators';
import { ExchangePanelComponent } from '../exchange/exchange-panel/exchange-panel.component';
import { TaskSettingWrapperComponent } from '../work-flow/task-definition-settings/task-setting-wrapper.component';
import { WorkflowTriggerSettingsComponent } from '../work-flow/workflow-trigger-settings/workflow-trigger-settings.component';
import { NoteTypesEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/note-types-editor/note-types-editor.component';
import { UsersEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/users-editor/users-editor.component';
import { EntityTypesEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/entity-types-editor/entity-types-editor.component';
import { ExchangeSyncContactComponent } from '../exchange/exchange-sync-contact/exchange-sync-contact.component';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { ThreadSideSheetComponent } from '../thread-side-sheet/thread-side-sheet.component';
import { ThreadSideSheetConfig } from '../thread-side-sheet/thread-side-sheet.view-model';
import { threadSideSheetDataSelector } from '../../redux/reducers/thread-view.reducer';
import { RelationshipsTypesEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/relationships-types-editor/relationships-types-editor.component';
import { NotificationEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/notification-editor/notification-editor.component';
import { PortfolioUploadEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/portfolio-upload-editor/portfolio-upload-editor.component';
import { ETLScheduledJobsEditorComponent } from '../admin-pages/admin-page-content/interface-config/etl-scheduled-jobs-editor.component';
import { LocalPythonScriptsEditorComponent } from '../admin-pages/admin-page-content/interface-config/local-python-scripts-editor.component';
import { ETLTasksEditorComponent } from '../admin-pages/admin-page-content/interface-config/etl-tasks-editor.component';
import { SEConfigurationEditorComponent } from '../admin-pages/admin-page-content/interface-config/se-configuration-edit.component';
import { WebSitesEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/web-sites-editor/web-sites-editor.component';
import { GeneralEditorComponent } from '../admin-pages/admin-page-content/admin-page-editors/general-editor/general-editor.component';

const COMPONENTS_WITHOUT_AUTO_CLOSE = [SlideSheetActionTypes.TASK_DEFINITION];
const BUTTON_CONTENT_IGNORE_BY_CLICK_OUTSIDE = [StringLiteralsPipe.translate('general.yes_want_make_change'), StringLiteralsPipe.translate('general.discard')];
@Component({
    selector: 'tam-slide-sheet',
    templateUrl: './slide-sheet.component.html',
    styleUrls: ['./slide-sheet.component.scss']
})
export class SlideSheetComponent implements OnInit, OnDestroy {

    @ViewChild('Container', { static: false, read: ViewContainerRef }) container: ViewContainerRef;

    autoClose = true;
    componentRef: ComponentRef<any>;
    show = false;
    SlideSheetSubComponent: Map<string, any> = new Map();
    width = 0;

    private _currentLoadComponentTypeInSlideSheet: string;
    /**
     * a SlideSheet Action Type which triggered the component loaded in the slide sheet.
     * And this one is a little different from _currentLoadComponentTypeInSlideSheet which records the last action type.
     *
     * @private
     * @type {string}
     * @memberof SlideSheetComponent
     */
    private _currentLoadedComponentReleventAction: SlideSheetActionTypes;
    private _destroySubscriptions: Array<Subscription> = [];
    private _documentClickSubscription: Array<Subscription> = [];
    private _instance: string;
    private _isValueChanged = false;
    private _isTriggerByNewProject = false;
    private _previousAction: { type: SlideSheetActionTypes, payload?: any };

    constructor(
        private _componentService: DynamicComponentService,
        private _messageService: MessageService,
        private _service: SlideSheetService,
    ) { }

    ngOnInit() {
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.TASK, TaskDetailComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.QUICK_TASK, QuickTaskComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.TASK_LIST, TaskListComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ENTITY_PANEL, EntityPanelComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.CONTACT_PANEL, ContactPanelComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.EXCHANGE_PANEL, ExchangePanelComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.THREAD_SIDESHEET, ThreadSideSheetComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.EXCHANGE_SYNC_CONTACT, ExchangeSyncContactComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.TASK_DEFINITION, TaskSettingWrapperComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.WORKFLOW_TRIGGER_SETTINGS, WorkflowTriggerSettingsComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_USERS_EDITOR, UsersEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_RELATIONSHIPS_EDITOR, RelationshipsTypesEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_NOTIFICATION_EDITOR, NotificationEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_PORTFOLIO_UPLOAD_EDITOR, PortfolioUploadEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_NOTE_EDITOR, NoteTypesEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_ENTITY_EDITOR, EntityTypesEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_STREET_EVENT_CONFIG, SEConfigurationEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_ETL_SCHEDULED_JOBS_EDITOR, ETLScheduledJobsEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_ETL_TASKS_EDITOR, ETLTasksEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_LOCAL_PYTHON_SCRIPT_EDITOR, LocalPythonScriptsEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_WEB_SITES_EDITOR, WebSitesEditorComponent);
        this.SlideSheetSubComponent.set(SlideSheetActionTypes.ADMIN_CONSOLE_GENERAL, GeneralEditorComponent);
        this._destroySubscriptions.push(
            this._service.slideSheetActionSubject$.pipe(debounceTime(0)).subscribe(action => this._onAction(action)),
        );
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroyListenDocumentClick();
    }

    onClick(event) {
        event['slideSheet'] = true;
    }

    onClickOutside(event) {
        if (this.show) { // only run this logic when slide sheet is shown
            if (COMPONENTS_WITHOUT_AUTO_CLOSE.includes(this._currentLoadedComponentReleventAction)) {
                // ignore the click-outside event, as the loaded component is in the white list, amoung which all components should not trigger auto-close of slide sheet.
                return;
            }

            if (this._currentLoadComponentTypeInSlideSheet === SlideSheetActionTypes.TASK ||
                this._currentLoadComponentTypeInSlideSheet === SlideSheetActionTypes.CHANGE_WIDTH) { // for now, only run for task detail, CHANGE_WIDTH is used to show the comments and history.
                // handle the discard button in alert dialog
                if (BUTTON_CONTENT_IGNORE_BY_CLICK_OUTSIDE.includes(event.innerText)) {
                    return;
                }
                if (!this._isValueChanged) { // close slide sheet if no data was changed
                    this._close();
                } else { // Throw the event to the component
                    this._service.slideSheetFeedbackSubject$.next({
                        type: SlideSheetEventTypes.CLICK_OUTSIDE_SLIDESHEET
                    });
                }
            }
        }
    }

    private _close() {
        this._service.slideSheetFeedbackSubject$.next({
            type: SlideSheetEventTypes.SLIDE_CLOSING,
            payload: {
                isTriggerByNewProject: this._isTriggerByNewProject,
                instance: this._instance
            }
        });
        this.show = false;
        this._service.isBeingShown = this.show;
        this._previousAction = null;
        this.autoClose = true;
        this.width = 0;
        this.container.clear();
        this._destroyListenDocumentClick();
    }

    private _createComponent(action): ComponentRef<any> {
        this.width = null;
        this._currentLoadedComponentReleventAction = action.type;
        const component = this.SlideSheetSubComponent.get(action.type);
        if (component) {
            return this._componentService.loadComponent(this.container, component, true);
        }
        return null;
    }

    private _destroyListenDocumentClick() {
        this._documentClickSubscription.forEach(item => {
            if (!item.closed) {
                item.unsubscribe();
            }
        });
        this._documentClickSubscription = [];
    }

    private _onAction(action: { type: SlideSheetActionTypes, payload?: any }): void {
        this._currentLoadComponentTypeInSlideSheet = action.type;
        this._service.isBeingShown = this.show;
        if (action.type === SlideSheetActionTypes.TASK) {
            this._isValueChanged = false;
            this.show = true;
            this._isTriggerByNewProject = action.payload.isTriggerByNewProject;
            this._instance = action.payload.instance;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = TASK_DETAIL_DEFAULT_WIDTH;
            this.componentRef.instance.task = lodash.cloneDeep(action.payload.task);
            this.componentRef.instance.instance = action.payload.instance;
            this.componentRef.instance.processDefinition = action.payload.processDefinition;
            // pass the data to task grid kanban if the field value on task detail is changed
            this._destroySubscriptions.push(
                this.componentRef.instance.feedbackSubject$.subscribe(isValueChanged => {
                    this._isValueChanged = isValueChanged;
                    this._service.slideSheetFeedbackSubject$.next({
                        type: SlideSheetEventTypes.VALUE_CHANGE,
                        payload: {
                            isValueChanged: isValueChanged
                        }
                    });
                }),
            );
            this._messageService.messageSubject$.next({
                type: MessageOperateType.DELETE,
                payload: {
                    id: action.payload.task.id
                },
            });
        } else if (action.type === SlideSheetActionTypes.QUICK_TASK) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.operationType = action.payload.operationType;
            this.componentRef.instance.quickTask = action.payload.quickTask;
            this.componentRef.instance.subTask = action.payload.subTask;
            this.componentRef.instance.closeAction = action.payload.closeAction;
        } else if (action.type === SlideSheetActionTypes.TASK_LIST) {
            if (action.payload === 'AutoChange') {
                this.show = true;
                this._previousAction = action;
                this.autoClose = true;
                this.componentRef = this._createComponent(action);
                this.width = 578;
            } else {
                if (this.show && this._previousAction && this._previousAction.type === SlideSheetActionTypes.QUICK_TASK && this.componentRef) {
                    const quickTaskComponent: ComponentRef<QuickTaskComponent> = this.componentRef;
                    quickTaskComponent.instance.onBtnCancel();
                } else {
                    if (this.show) {
                        this._close();
                    } else {
                        this.show = true;
                        this._previousAction = action;
                        this.autoClose = true;
                        this.componentRef = this._createComponent(action);
                        this.width = 578;
                    }
                }
            }
        } else if (action.type === SlideSheetActionTypes.ENTITY_PANEL ||
            action.type === SlideSheetActionTypes.CONTACT_PANEL ||
            action.type === SlideSheetActionTypes.EXCHANGE_PANEL) {
            if (!this._previousAction || this._previousAction.payload !== action.payload) {
                this.show = true;
                this._previousAction = action;
                this.autoClose = true; // set default value for autoClose to avoid openning slide sheet continuously. please refer TAM-35496 for detail.
                // this.autoClose = action.payload.slideSheetAutoClose;
                if (action.type === SlideSheetActionTypes.EXCHANGE_PANEL) {
                    this.autoClose = false;
                }
                this.componentRef = this._createComponent(action);
                this.width = 578;
                this.componentRef.instance.entityID = action.payload;
                this.componentRef.instance.eventKey = 'slideSheet';
                this.componentRef.instance.eventValue = true;
            }
        } else if (action.type === SlideSheetActionTypes.THREAD_SIDESHEET) {
            if (!this._previousAction || this._previousAction.payload !== action.payload) {
                this.show = true;
                this._previousAction = action;
                this.autoClose = true;
                this.componentRef = this._createComponent(action);
                this.width = 578;
                const threadSideSheetConfig = new ThreadSideSheetConfig();
                threadSideSheetConfig.dataStoreSelector = threadSideSheetDataSelector;
                this.componentRef.instance.config = threadSideSheetConfig;
                this.componentRef.instance.eventKey = 'slideSheet';
                this.componentRef.instance.eventValue = true;
            }
        } else if (action.type === SlideSheetActionTypes.TASK_DEFINITION) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 468;
            const opType = action.payload.opType;
            const isImport = action.payload.isImport;
            delete action.payload.opType;
            this.componentRef.instance.config = action.payload;
            this.componentRef.instance.opType = opType;
            this.componentRef.instance.isImport = isImport;
        } else if (action.type === SlideSheetActionTypes.WORKFLOW_TRIGGER_SETTINGS) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 500;
            this.componentRef.instance.config = action.payload;
        } else if (action.type === SlideSheetActionTypes.CHANGE_WIDTH) {
            this.width = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_USERS_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.userData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_NOTE_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.noteData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_RELATIONSHIPS_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.noteData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_ENTITY_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.entityData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_NOTIFICATION_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.notificationData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_PORTFOLIO_UPLOAD_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.portfolioData = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_ETL_SCHEDULED_JOBS_EDITOR ||
            action.type === SlideSheetActionTypes.ADMIN_CONSOLE_STREET_EVENT_CONFIG ||
            action.type === SlideSheetActionTypes.ADMIN_CONSOLE_ETL_TASKS_EDITOR ||
            action.type === SlideSheetActionTypes.ADMIN_CONSOLE_LOCAL_PYTHON_SCRIPT_EDITOR ||
            action.type === SlideSheetActionTypes.ADMIN_CONSOLE_WEB_SITES_EDITOR) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.data = action.payload;
        } else if (action.type === SlideSheetActionTypes.ADMIN_CONSOLE_GENERAL) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            this.width = 578;
            this.componentRef.instance.data = action.payload.data;
            this.componentRef.instance.type = action.payload.type;
        } else if (action.type === SlideSheetActionTypes.EXCHANGE_SYNC_CONTACT) {
            this.show = true;
            this._previousAction = action;
            this.autoClose = false;
            this.componentRef = this._createComponent(action);
            // need set isFromAdminSetting for judge admin or user.
            this.componentRef.instance.isFromAdminSetting = action.payload.isFromAdminSetting;
            this.width = 578;
        } else if (action.type === SlideSheetActionTypes.CLOSE) {
            // Need to reset the parameter when cancel slide sheet manually
            this._service.slideSheetFeedbackSubject$.next({
                type: SlideSheetEventTypes.VALUE_CHANGE,
                payload: {
                    isValueChanged: false
                }
            });

            if (action.payload && action.payload.isTriggerNewFlagNeedToReset) {
                this._isTriggerByNewProject = false;
            }

            this._close();
        }
        if ((!this._documentClickSubscription.length || this._documentClickSubscription[0].closed) && this.autoClose && action.type !== SlideSheetActionTypes.CLOSE) {
            this._documentClickSubscription.push(
                fromEvent(document, 'click').pipe(
                    debounceTime(0), // for 3rd party library, like contextMenu & AgGrid
                ).subscribe((event) => {
                    if (!event['slideSheet'] && this.autoClose) {
                        this._close();
                    }
                }),
                fromEvent(document, 'mousedown').subscribe((event) => {
                    if (!event['slideSheet'] && this.autoClose) {
                        this._close();
                    }
                }),
            );
        }
    }
}
